import React, { useMemo } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AllModel from 'src/pages/AllModel';
import Journal from 'src/pages/Journal';
import MyModel from 'src/pages/MyModel';
import { RoleEnum } from 'src/utils/enum';
import { ErrorUrlEnum, PrivateRoutesEnum } from 'src/utils/router';
import { storageRole } from 'src/utils/storage';
import { Error404 } from '../Error404';
import ErrorHandler from '../ErrorHandler';
import PrivateRoute from '../PrivateRoute';
import Administration from 'src/pages/Administration';

const AppRouter: React.FC = () => {
  const directUser = useMemo(() => {
    if (storageRole() === RoleEnum.USER) {
      return PrivateRoutesEnum.MY_MODEL;
    } else if (storageRole() === RoleEnum.SECURITY) {
      return PrivateRoutesEnum.JOURNAL;
    }
    return PrivateRoutesEnum.ALL_MODEL;
  }, []);
  return (
    <Routes>
      <Route path={`${ErrorUrlEnum.ERROR}/*`} element={<ErrorHandler />} />
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/" element={<Navigate to={directUser} />} />
        <Route path={PrivateRoutesEnum.MY_MODEL} element={<MyModel />} />
        <Route path={PrivateRoutesEnum.ALL_MODEL} element={<AllModel />} />
        <Route
          path={PrivateRoutesEnum.ADMINISTRATION}
          element={<Administration />}
        />
        <Route path={PrivateRoutesEnum.JOURNAL} element={<Journal />} />
      </Route>
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};

export default AppRouter;
